import { IconButton, Menu, MenuItem } from "@mui/material";
import { useCallback, useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import styled from "styled-components";

interface IProps {
  version: number;
  isCurrentVersion: boolean;
  onSetActive: (version: number) => any;
}

const ActionMenuText = styled.p`
  margin-top: 0px;
  margin-bottom: 0px;
  line-height: 20px;
  font-size: 14px;
  word-wrap: break-word;
`;

export const RulesListContextMenu = ({ version, isCurrentVersion, onSetActive }: IProps) => {
  const [anchorEl, setAnchorEl] = useState(null);

  function handleMenuClick(e: any) {
    setAnchorEl(e.currentTarget);
  }

  const handleMenuItemClick = useCallback(() => {
    onSetActive(version);
    setAnchorEl(null);
  }, [onSetActive, version]);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return (
    <>
      <IconButton
        key={version}
        aria-owns={anchorEl ? `${version}-menu` : undefined}
        aria-haspopup="true"
        onClick={handleMenuClick}
        disabled={isCurrentVersion}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id={`${version}-menu`}
        anchorEl={anchorEl}
        transformOrigin={{ vertical: "bottom", horizontal: "left" }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleMenuItemClick}>
          <ActionMenuText>Set to active</ActionMenuText>
        </MenuItem>
      </Menu>
    </>
  );
};
